import { useEffect } from 'react'

import {
  ExtendSessionResponse,
  extendSession,
  extendSessionVariables,
} from 'types/graphql'
import { useIsMounted } from 'usehooks-ts'

import { TypedDocumentNode, useMutation } from '@cedarjs/web'

import { useEmrAuth } from 'src/auth'

const EXTEND_SESSION_MUTATION: TypedDocumentNode<
  extendSession,
  extendSessionVariables
> = gql`
  mutation extendSession {
    extendSession {
      sessionExpiresAt
    }
  }
`

export const useExtendSession = (periodMilliseconds: number) => {
  const { currentUser, reauthenticate } = useEmrAuth()
  const [extendSession] = useMutation<ExtendSessionResponse, void>(
    EXTEND_SESSION_MUTATION
  )
  const isMounted = useIsMounted()
  useEffect(() => {
    let id: NodeJS.Timeout

    if (currentUser) {
      id = setInterval(() => {
        if (isMounted()) {
          extendSession().catch(() => {
            reauthenticate()
          })
        }
      }, periodMilliseconds)
    }

    return () => {
      if (id) {
        clearInterval(id)
      }
    }
  }, [
    currentUser,
    extendSession,
    periodMilliseconds,
    reauthenticate,
    isMounted,
  ])
}
